<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
  description: string;
  to: string;
}>();
</script>

<template>
  <NuxtLink
    :to="to"
    class="group flex flex-col rounded-2xl border border-gray-200 bg-white p-6 shadow-[var(--shadow-card)] transition-all duration-200 hover:-translate-y-1 hover:shadow-[var(--shadow-card-hover)] hover:border-brand-200"
  >
    <div class="mb-4 flex size-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-colors">
      <UIcon
        :name="icon"
        class="size-6"
      />
    </div>
    <h3 class="text-lg font-semibold text-gray-900 mb-2">
      {{ title }}
    </h3>
    <p class="text-sm text-gray-600 mb-4 flex-1">
      {{ description }}
    </p>
    <span class="inline-flex items-center gap-1 text-sm font-semibold text-brand-600 group-hover:gap-2 transition-all">
      Learn more
      <UIcon
        name="i-heroicons-arrow-right-20-solid"
        class="size-4"
      />
    </span>
  </NuxtLink>
</template>
